import { api, get } from "../api";

export async function getPays() {
    return await api.get("client/pays");
}

export async function getProvinces(idPays) {
    return await api.get(`client/provinces/${idPays || "CANADA"}`);
}

export async function getClientName(idClient) {
    return await api.get(`client/getClientName/${idClient}`);
}

export async function getClientByNomPrenomTel(nom, prenom, telephones) {
    return await api.get(`client/getClientByNomPrenomTel/${nom}/${prenom}/${telephones}`);
}

export async function getInscriptionTirageByClient(idTirage, idClient) {
    return await api.get(`tirage/getInscriptionTirageByClient/${idTirage}/${idClient}`);
}

export async function getPublicite() {
    return await api.get("publicite");
}

export function isClientMembreByDossier(client, startDate) {
    return api.get(`Client/isMembre?dossier=${client.idDossier}&prenom=${client.firstName}&nom=${client.lastName}&telephone=${client.number}&startDate=${startDate}`);
}

export async function getClientIsMembreByIdProfile(idProfile) {
    return await api.get(`client/isMembreByIdProfile/${idProfile}`)
}

export async function isCodeClientExists(codeClient) {
    return await api.get(`client/IsCodeClientExists/${codeClient}`);
}

export function getIdClientByProfilePav(idProfile) {
    return api.get(`Profile/${idProfile}/IdClient`);
}

export function getFacturesHistoriqueByIdProfilePav(idProfile) {
    return api.get(`Profile/${idProfile}/facturesHistorique`);
}

export function getFacturesDuesHistoriqueByIdProfilePav(idProfile) {
    return api.get(`Profile/${idProfile}/facturesDuesHistorique`);
}

export function getDepotRequisByIdProfilePav(idProfile) {
    return api.get(`Profile/${idProfile}/DepotRequis`);
}

export function getSoldeDepotRequisByIdProfilePav(idProfile) {
    return api.get(`Profile/${idProfile}/SoldeDepotRequis`);
}

export function getFacturesHistoriqueByIdClient(idClient) {
    return api.get(`client/${idClient}/facturesHistorique`);
}

export function getCachesHistoriqueByIdClient(idClient) {
    return api.get(`Profile/${idClient}/cachesHistorique`);
}